/**
 * Adrenal Reserve: hurt makes you faster, not slower.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const ADRENAL_RESERVE = {
  id: 'adrenalReserve',
  branch: 'survival',
  tier: 2,
  title: 'Adrenal Reserve',
  blurb: 'The body keeps a little back. It was never asked whether it minded.',
  maxRanks: 3,
  minLevel: 9,
  requires: ['sensibleShoes'],
  statGrants: {},
  effects: [{ field: 'moveSpeed', perRank: 0.05, condition: 'whileHurt' }],
  damageModifiers: [],
} as const satisfies Perk;
